import { createContext } from "react";

const SnackbarContext = createContext({
    setOpenSnackbar: (newValue) => {},
    setSnackbarMessage: (newValue) => {},
    setSnackbarSeverity: (newValue) => {},
});

export default SnackbarContext;